import { notification } from "antd";

export const NOTIFICATION_PLACEMENTS = {
    TOPRIGHT: 'topRight',
    TOPLEFT: 'topLeft',
    BOTTOMLEFT: 'bottomLeft',
    BOTTOMRIGHT: 'bottomRight'
};

export const NOTIFICATION_TYPES = {
    SUCCCESS: 'success',
    WARNING: 'warning',
    INFO: 'info',
    ERROR: 'error'
};

export const NotificationHandler = (configuration) => {
    notification[configuration.type]({
        message: configuration.message,
        description: configuration.description,
        placement: configuration.placement,
        duration: 2
      });
}